import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { homeAni } from "./animation";
import MailComp from "./MailComp";
import { TopNav } from "./TopNav";

function AboutPageComp({ props }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulNewAbout {
        nodes {
          intro {
            intro
          }
          others {
            others
          }
        }
      }
    }
  `);

  const {
    allContentfulNewAbout: {
      nodes: [{ intro, others }],
    },
  } = data;

  return (
    <>
      <div className="about--page--wrapper">
        <main className="about--main">
          <TopNav path={props.location.pathname} />
          <div className="about--content">
            <motion.div className="about--top">
              <motion.h1
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.6, duration: 0.6 },
                }}
                transition={{ duration: 0.8 }}
              >
                About myself
              </motion.h1>
              <motion.p
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.5, duration: 0.6 },
                }}
                transition={{ duration: 0.8, delay: 0.5 }}
              >
                {intro.intro}
              </motion.p>
            </motion.div>
            <div className="about--bottom">
              <motion.h2
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.6, duration: 0.8 },
                }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                The Books i have read related to web dev and design
              </motion.h2>
              <motion.p
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.7, duration: 0.8 },
                }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                {others.others}
              </motion.p>
            </div>
            <div className="get--in--touch">
              <motion.h2
                variants={homeAni}
                initial="initial"
                animate="animate"
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { delay: 0.8, duration: 0.2 },
                }}
                transition={{ duration: 0.8, delay: 0.5 }}
              >
                Impressed?
              </motion.h2>
              <MailComp
                exit={{
                  y: 100,
                  opacity: 0,
                  transition: { duration: 0.8 },
                }}
                transition={{ duration: 0.8, delay: 0.6 }}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export { AboutPageComp };
